import { AuthProvider } from 'oidc-react';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import AccountPage from './pages/AccountPage';
import BookmarksPage from './pages/BookmarksPage';
import MockPage from './pages/MockPage';
import NewslettersPage from './pages/NewslettersPage';
import OrdersPage from './pages/OrdersPage';
import ProfilePage from './pages/ProfilePage';
import SignInPage from './pages/SignInPage';
import SignOutPage from './pages/SignOutPage';
import { env } from './env';
import { history } from './common/helpers';
import PageLayout from './common/components/PageLayout';

const oidcConfig = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onBeforeSignIn: () => {
    var location = window.location.href;
    localStorage.setItem('location', location);
    return 'true';
  },
  onSignIn: async (user: any) => {
    window.location.hash = '';
  },
  authority: env.REACT_APP_AUTHORITY_URL,
  clientId: env.REACT_APP_OIDC_CLIENT,
  responseType: env.REACT_APP_OIDC_RESPONSE,
  redirectUri: env.REACT_APP_REDIRECT_URL,
  scope: 'openid profile',
  loadUserInfo: true,
  disablePKCE: false,
};

function App() {
  const isMock = window.name === 'true';
  history.navigate = useNavigate();
  history.location = useLocation();

  return isMock ? (
    <>
      <PageLayout>
        <Routes>
          <Route path='/mock' element={<MockPage />} />;
          <Route path='/signin' element={<SignInPage />} />;
          <Route path='/' element={<Navigate to='/profile' />} />;
          <Route path='/account' element={<AccountPage />} />;
          <Route path='/profile' element={<ProfilePage />} />;
          <Route path='/newsletters' element={<NewslettersPage />} />;
          <Route path='/orders' element={<OrdersPage />} />;
          <Route path='/bookmarks' element={<BookmarksPage />} />;
          <Route path='/signout' element={<SignOutPage />} />;
        </Routes>
      </PageLayout>
    </>
  ) : (
    <>
      <Routes>
        <Route path='/mock' element={<MockPage />} />;
      </Routes>
      <AuthProvider {...oidcConfig}>
        <PageLayout>
          <Routes>
            <Route path='/signin' element={<SignInPage />} />;
            <Route path='/' element={<Navigate to='/profile' />} />;
            <Route path='/account' element={<AccountPage />} />;
            <Route path='/profile' element={<ProfilePage />} />;
            <Route path='/newsletters' element={<NewslettersPage />} />;
            <Route path='/orders' element={<OrdersPage />} />;
            <Route path='/bookmarks' element={<BookmarksPage />} />;
            <Route path='/signout' element={<SignOutPage />} />;
          </Routes>
        </PageLayout>
      </AuthProvider>
    </>
  );
}

export default App;
